<template>

  <t-page>

    <ChecklistEnvironmentOccurrenceDialog
        :checklist-item-id="modalOccurrenceItemId"
        :type-checklist-item="modalOccurrenceItemName"
        :checklist-environment-id="modalChecklistEnvironmentId"
        :enterprise-id="form.enterpriseId"
        :occurrence="modalOccurrenceItem"
        :business-type-survey="form.businessTypeSurvey"
        :user-access-budget-show-price="relationAccessSubValidation('sub-checklist-budget-show-price')"
        v-if="modalOccurrenceItemShow"
        @onClose="onCloseModalOccurrenceItem"
    />


    <t-page-form tabs
                 :set-tab-index="tabIndex"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :submit-text="command === 'delete' ? currentPage.singularTitle : 'Finalizar Inspeção'"
                 :submit-text-not-default="command !== 'delete'"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #title-buttons>

        <t-button @click="onShareURL"
                  v-show="(command === 'delete' || command === 'view') && form.statusChecklist === StatusChecklistType.type.FINISHED && form.shareType === ChecklistShareType.type.SHARE_ALL_PHOTOS">
          <b-icon-share/>
          Compartilhar
        </t-button>

        <t-button
            @click="downloadChecklistPhotos"
            :sending="onDownloadChecklistPhotos"
            enable-loader>
          <b-icon-arrow-down-circle/>
          Download Fotos
        </t-button>

        <t-button
            @click="openChecklistReport(form.statusChecklist,form.enterpriseId,form.checklistId,form.typeChecklistId,form.checklistNumber, form.businessTypeSurvey)">
          <b-icon-printer/>
          Gerar Relatório
        </t-button>

        <b-button
            v-if="form.businessTypeSurvey === SurveyType.type.BUDGET && objValid(form.quoteId) && form.quoteId > 0"
            variant="outline-primary"
            target="_blank"
            class="mr-3"
            :to="{path:'/business/quote/'+form.quoteNumber}">
          <b-icon-box-arrow-up-right/>
          Orçamento
        </b-button>


        <!--        <t-button @click="sendQueueWordReport('checklist',form.checklistId,'Inspeção nº ' + form.checklistNumber)"
                          v-show="(command !== 'delete') && getRenderRule('enableWordReport')">
                  <b-icon-file-word class="mr-1"></b-icon-file-word>
                  Enviar Fila do Word
                </t-button>-->

        <t-button @click="confirmReverse()"
                  outline-danger
                  v-show="(command === 'delete' || command === 'view') && form.statusChecklist === StatusChecklistType.type.FINISHED"
                  :sending="reverseFinish"
                  enable-loader
                  :title="!relationAccessSubValidation('sub-checklist-reverse-finish') ? 'Perfil de acesso não habilitado para estorno de finalização' : ''"
                  :disabled="!relationAccessSubValidation('sub-checklist-reverse-finish')">
          <b-icon-clipboard-x class="mr-1"></b-icon-clipboard-x>
          Estornar finalização
        </t-button>

      </template>

      <template #default>

        <t-form-tab title="Inspeção" @onClick="getChecklist()">

          <div class="p-2 mb-2">
            <t-msg danger v-if="isDelete()">

              Atenção ao excluir a Inspeção todos os processos relacionados a mesma serão excluídos automaticamente
              como:
              <ul>
                <li>Fotos inseridas durante esta Inspeção</li>
                <li v-show="enableOccurrence">Apontamentos novos serão excluídos por completo</li>
                <li v-show="enableOccurrence">Apontamentos finalizados voltaram para pendentes</li>
                <li v-show="enableOccurrence">Exclusão de relatório de apontamentos por Inspeção que estiverem
                  disponíveis para download
                </li>
              </ul>

              <br/><br/>
              Este processo é irreversível, verifique se realmente deseja continuar ou faça um estorno da finalização e
              edite as informações desejadas e depois finalize novamente.


            </t-msg>

          </div>


          <t-form-card title="Dados Básicos">

            <b-row v-if="objValid(form.otherCodeLabel)">

              <t-input v-model="form.checklistNumber"
                       lpad="4"
                       cols="3"
                       label="Cód. Inspeção"
                       fixed
                       highlight/>

              <t-input cols="3" v-model="form.otherCodeLabel" highlight fixed label="Cód. Interno"/>

              <t-input cols="3" v-model="form.issueDate" date fixed label="Data Inspeção" required/>

              <t-input cols="3" v-model="form.inspector" fixed label="Inspetor"/>

            </b-row>

            <b-row v-else>


              <t-input v-model="form.checklistNumber"
                       lpad="4"
                       cols="4"
                       label="Cód. Inspeção"
                       fixed
                       highlight/>

              <t-input cols="4" v-model="form.issueDate" date fixed label="Data Inspeção" required/>

              <t-input cols="4" v-model="form.inspector" fixed label="Inspetor"/>


            </b-row>


            <b-row v-show="accountModule !== 'estate'">

              <t-input cols="2" v-model="form.enterpriseCodeLabel" fixed :label="'Cód.'+enterpriseLabelByModule"/>

              <t-input :cols="enterpriseStepOptions.length > 0 ? 6 : 9" v-model="form.enterprise" fixed
                       label="Empreendimento"/>

              <t-input cols="3" v-if="enterpriseStepOptions.length > 0" @change="updateEnterpriseStep"
                       v-model="form.enterpriseStepId" select
                       :options="enterpriseStepOptions"
                       label="Fase"
              />


            </b-row>

            <b-row>

              <t-input cols="3" v-model="form.enterpriseZipcode" fixed label="CEP"/>

              <t-input cols="9" v-model="form.enterpriseAddressFull" fixed label="Endereço"/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.enterpriseNeighborhood" fixed label="Bairro"/>

              <t-input cols="6" v-model="form.enterpriseCityFull" fixed label="Cidade - UF"/>

            </b-row>

            <b-row>

              <t-input cols="4" style="max-width: 300px" v-model="form.typeChecklistStatus"
                       v-if="form.typeChecklistStatus !== ''" fixed
                       label="Status Operacional"/>


              <b-col cols="4" v-if="form.typeChecklist !== ''">
                <t-input v-model="form.typeChecklist" fixed label="Modelo de Inspeção"/>
              </b-col>

              <b-col cols="4" style="max-width: 300px">

                Status Checklist

                <div
                    v-if="form.statusChecklist=== StatusChecklistType.type.PENDING"
                    class="border p-2 b-radius mt-1 d-flex">

                    <span class="badge badge-dot badge-dot-xl mr-2 badge-danger"
                          style="margin-top:2px"></span>

                  <div style="font-size: 15px;" class="text-danger"> Pendente</div>

                </div>

                <div
                    v-else
                    class="border p-2 b-radius mt-1 d-flex">
                    <span class="badge badge-dot badge-dot-xl mr-2 badge-success"
                          style="margin-top:2px"></span>

                  <div style="font-size: 15px;" class="text-success"> Finalizada</div>

                </div>


              </b-col>

            </b-row>


          </t-form-card>


          <t-form-card title="Resumo desta Inspeção">


            <div v-show="enableOccurrence" class="no-gutters row">
              <div class="col-sm-12 col-md-4 col-xl-4">
                <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg opacity-9 bg-success d-flex align-items-center justify-content-center">
                      <b-icon-clipboard-check style="scale: 1.7" class="text-white"/>
                    </div>

                  </div>
                  <div class="widget-chart-content">
                    <div class="widget-subheading">Apontamentos Finalizados
                      <t-help title="Apontamentos finalizadas através deste checklist"/>
                    </div>
                    <div class="widget-numbers text-success"><span>{{ form.qtyGeneralOccurrencesDone }}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-xl-4">
                <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg opacity-9 bg-warning d-flex align-items-center justify-content-center">
                      <b-icon-clipboard-minus style="scale: 1.7" class="text-white"/>
                    </div>
                  </div>
                  <div class="widget-chart-content">
                    <div class="widget-subheading">Apontamentos Pendentes
                      <t-help
                          title="Apontamentos que estavam pendentes e que continuam da mesma forma após este checklist ser realizado"/>
                    </div>
                    <div class="widget-numbers">{{ form.qtyGeneralOccurrencesPending }}</div>
                  </div>
                </div>
                <div class="divider m-0 d-md-none d-sm-block"></div>
              </div>
              <div class="col-sm-6 col-md-4 col-xl-4">
                <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                  <div class="icon-wrapper rounded-circle">

                    <div class="icon-wrapper-bg opacity-9 bg-danger d-flex align-items-center justify-content-center">
                      <b-icon-clipboard-plus style="scale: 1.7" class="text-white"/>
                    </div>


                  </div>
                  <div class="widget-chart-content">
                    <div class="widget-subheading">Apontamentos novos
                      <t-help title="Apontamentos novos com origem neste checklist"/>
                    </div>
                    <div class="widget-numbers"><span>{{ form.qtyGeneralOccurrencesNew }}</span></div>
                  </div>
                </div>
                <div class="divider m-0 d-md-none d-sm-block"></div>
              </div>
            </div>

            <b-row>

              <div class="col-sm-12 col-md-3">
                <div class="widget-content p-0">
                  <div class="widget-content-outer">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left">
                        <div class="widget-numbers text-dark">
                          <span v-if="form.qtyEnvironmentTotal > 0">{{
                              ((form.qtyEnvironmentFinished / form.qtyEnvironmentTotal) * 100) | number(2)
                            }}%</span>
                          <span v-else>0%</span>
                        </div>
                      </div>
                    </div>
                    <div class="widget-progress-wrapper mt-1">
                      <div class="progress-bar-xs progress-bar-animated-alt progress">
                        <div class="progress-bar bg-info" role="progressbar" aria-valuemin="0"
                             aria-valuemax="100"
                             :style="{'width':((form.qtyEnvironmentFinished/form.qtyEnvironmentTotal)*100)+'%'}"></div>
                      </div>
                      <div class="progress-sub-label">
                        <div class="sub-label-left font-size-md text-dark">Ambientes inspecionados:
                          {{ form.qtyEnvironmentResume }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-3" v-show="enableOccurrence">
                <div class="widget-content p-0">
                  <div class="widget-content-outer">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left">
                        <div class="widget-numbers text-dark">
                          {{ ((form.qtyGeneralItemsOk / form.qtyGeneralItemsTotal) * 100) | number(2) }}%
                        </div>
                      </div>
                    </div>
                    <div class="widget-progress-wrapper mt-1">
                      <div class="progress-bar-xs progress-bar-animated-alt progress">
                        <div class="progress-bar bg-info" role="progressbar" aria-valuemin="0"
                             aria-valuemax="100"
                             :style="{'width':((form.qtyGeneralItemsOk/form.qtyGeneralItemsTotal)*100)+'%'}">
                        </div>
                      </div>
                      <div class="progress-sub-label">
                        <div class="sub-label-left font-size-md text-dark">Itens sem apontamentos ou finalizados
                          <t-help title="Itens sem nenhum apontamento nova ou pendente."/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-3">

                <div>

                  <span class="sub-label-left font-size-md text-dark opacity-6">Tempo de inspeção</span>
                  <t-help click><p><b>Data considerada para finalização da inspeção</b></p>

                    <p>A data de finalização da inspeção passa a ser definida com base na finalização dos ambientes.</p>

                    <p>Para fins de cálculo do tempo de inspeção, será considerada a diferença entre a data inicial da
                      inspeção e a data de finalização do último ambiente.</p>

                    <p>Mesmo que a inspeção permaneça não finalizada ou não sincronizada, o tempo será calculado com
                      base no último ambiente finalizado.</p>
                  </t-help>
                  <div style="font-size: 30px">
                    <b-icon-clock class="mr-1"/>
                    {{ form.elapsedTimeTotal | minuteOrHour }}

                  </div>
                </div>

              </div>

              <div class="col-sm-12 col-md-3">

                <div>

                  <span class="sub-label-left font-size-md text-dark opacity-6">Qtd. Fotos Geral</span>
                  <div style="font-size: 30px">
                    <b-icon-images class="mr-1"/>
                    {{ form.qtyGeneralFile }}

                  </div>

                </div>

              </div>

            </b-row>

          </t-form-card>

          <div v-show="form.businessTypeSurvey === SurveyType.type.ESTATE">
            <t-form-card title="Locação Detalhes">


              <b-row>

                <t-input cols="6" @focusout="updateGeneralInformation" v-model="form.estateClean"
                         label="Faxinado"/>

                <t-input cols="6" @focusout="updateGeneralInformation" v-model="form.estateLeaseGuarantee"
                         label="Garantia de Locação"/>

              </b-row>

              <b-row>

                <!--                <t-input cols="4" v-model="form.estateLeaseIssueDate" date
                                         label="Data Inspeção"/>-->


                <t-input cols="6" @focusout="updateGeneralInformation" date v-model="form.estateLeaseInitialDate"
                         label="Início Locação"/>

                <t-input cols="6" @focusout="updateGeneralInformation" date v-model="form.estateLeaseFinalDate"
                         label="Término Locação"/>

              </b-row>

              <b-row>

                <t-input cols="6" @focusout="updateGeneralInformation" v-model="form.estateIntroText" textarea
                         max-length="2000"
                         label="Texto de Introdução no laudo"/>

                <t-input cols="6" @focusout="updateGeneralInformation" v-model="form.estateFinishText" textarea
                         max-length="2000"
                         label="Texto de Encerramento no laudo"/>


              </b-row>


            </t-form-card>


            <t-form-card title="Inspeção Comparativa" v-if="form.compareChecklistId > 0">

              <t-msg info>Informações sobre a inspeção inicial</t-msg>

              <b-row>

                <t-input cols="4" v-model="checklistOrigin.checklistNumber" label="Cód. Inspeção Origem" lpad="4"
                         fixed/>

                <t-input cols="4" v-model="checklistOrigin.issueDate" label="Data Inspeção Inicial" date fixed/>

                <t-input cols="4" v-model="checklistOrigin.inspector" label="Inspetor" fixed/>


              </b-row>

              <b-button
                  :to="{path: '/checklist/'+checklistOrigin.checklistNumber}"
                  class="mt-2"
                  variant="outline-primary" target="_blank">
                <b-icon-box-arrow-up-right class="mr-2"/>
                Detalhar Inspeção de Origem
              </b-button>

            </t-form-card>

          </div>

          <t-form-card title="Apontamentos deste Empreendimento" v-show="enableOccurrence">

            <t-msg info>Resumo de apontamentos de forma geral em relação ao empreendimento e não somente desta
              inspeção
            </t-msg>


            <div class="row" style="max-width: 600px">

              <div class="col-md-5">

                <div class="widget-subheading text-danger" style="opacity: 1; font-size:13px">Geral Pendentes</div>

                <div class="card bg-danger widget-chart text-white card-border text-left link link-shadow"
                     @click="goPath('/checklist/occurrence?enterpriseId='+form.enterpriseId+'&hasOccurrencePending=true')">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg bg-white opacity-2"></div>
                    <i class="text-white"><img style="filter: invert(1);"
                                               src="https://custom.onlaine.com.br/assets/fonts/Linearicons/hourglass.svg"></i>
                  </div>

                  <div class="widget-numbers">{{ form.enterpriseQtyOccurrencePending }}</div>


                </div>

              </div>

              <div class="col-md-5">

                <div class="widget-subheading text-success" style="opacity: 1; font-size:13px">Geral Finalizados</div>

                <div class="card bg-success widget-chart text-white card-border text-left link link-shadow"
                     @click="goPath('/checklist/occurrence?enterpriseId='+form.enterpriseId+'&hasOccurrencePending=false')">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg bg-white opacity-2"></div>
                    <i class="text-white"><img style="filter: invert(1);"
                                               src="https://custom.onlaine.com.br/assets/fonts/Linearicons/checkmark-circle.svg"></i>
                  </div>
                  <div class="widget-numbers">{{ form.enterpriseQtyOccurrenceFinish }}</div>

                </div>
              </div>


            </div>


          </t-form-card>


          <t-form-card title="Observações">

            <t-input textarea v-model="form.note" @focusout="updateGeneralInformation" hide-label
                     label="Observações gerais desta inspeção" max-length="1000"/>

          </t-form-card>

          <t-form-card title="Origem" v-if="form.enableSingleEnvironment || form.scheduleId > 0">

            <div v-if="form.enableSingleEnvironment">

              <b-card-title>Ambiente exclusivo</b-card-title>

              <b-row>

                <t-input cols="2" v-model="form.environmentCodeLabel" fixed label="Cód. Amb."/>

                <t-input cols="5" v-model="form.environment" fixed label="Ambiente"/>

                <t-input cols="5" v-model="form.spotFolder" fixed label="Pavimento"/>

              </b-row>


            </div>

            <div v-else-if="form.scheduleId > 0">

              <b-card-title>Agenda de Inspeção</b-card-title>

              <b-row>


                <t-input cols="3" v-model="form.scheduleStartDate" date fixed label="Data Inicial"
                         help="Data especificada para início da inspeção"/>

                <t-input cols="3" v-model="form.scheduleStartTime" time fixed label="Horário Inicial"
                         help="Horário sugestão para início da inspeção"/>

                <t-input cols="3" v-model="form.scheduleFinishDate" date fixed label="Data Final"
                         help="Data especificada limite para realização da inspeção"/>

                <t-input cols="3" v-model="form.scheduleFinishTime" time fixed label="Horário Final"
                         help="Horário sugestão de término da inspeção"/>


              </b-row>

            </div>

          </t-form-card>


          <t-form-card title="Localização">


            <div
                v-if="(form.initialLat !== undefined && form.initialLat !== 0) || (form.finalLat !== undefined && form.finalLat !== 0)">

              <t-msg info v-if="form.platformOrigin === ChecklistPlatformType.type.WEB">Localização não é precisa por
                conta da plataforma web utilizada para realização do checklist
              </t-msg>

              <b-row>

                <b-col cols="6">

                  <b-card-title>Início: {{ form.initialDate | datetime }}</b-card-title>

                  <t-map
                      bordered
                      v-if="form.initialLat !== undefined && form.initialLat !== 0"
                      :latitude="form.initialLat"
                      :zoom="form.platformOrigin === ChecklistPlatformType.type.WEB ? 14 : 16"
                      :longitude="form.initialLng"/>

                </b-col>

                <b-col cols="6" v-if="form.finalDate !== undefined && form.finalDate !== ''">

                  <b-card-title>Término: {{ form.finalDate | datetime }}</b-card-title>

                  <t-map
                      bordered
                      v-if="form.finalLat !== undefined && form.finalLat !== 0"
                      :latitude="form.finalLat"
                      :zoom="form.platformOrigin === ChecklistPlatformType.type.WEB ? 14 : 16"
                      :longitude="form.finalLng"/>

                </b-col>

              </b-row>

            </div>

            <t-msg v-else warning>Localização de início ou término não identificada</t-msg>


          </t-form-card>

          <t-form-card title="Dispositivo">

            <b-row>

              <t-input v-model="form.platformOrigin" :options="ChecklistPlatformType.list" radio cols="6" fixed
                       label="Plataforma"/>

              <t-input v-model="form.mobileDevice.systemType" cols="6" fixed label="Categoria"/>

            </b-row>

            <b-row>

              <t-input v-model="form.mobileDevice.device" cols="6" fixed label="Modelo"/>

              <t-input v-model="form.mobileDevice.systemVersion" cols="6" fixed label="Versão"/>

            </b-row>


          </t-form-card>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Ambientes" hash="environment" lazy>


          <ChecklistEnvironment :status-checklist="form.statusChecklist"
                                :business-type-survey="form.businessTypeSurvey"
                                :business-evidence-file-required-fields="form.businessEvidenceFileRequiredFields"
                                :business-evidence-file-label-order-fields="form.businessEvidenceFileLabelOrderFields"
                                :enable-reverse-finish="relationAccessSubValidation('sub-checklist-reverse-finish')"
                                :user-access-budget-show-price="relationAccessSubValidation('sub-checklist-budget-show-price')"
                                :enable-occurrence="enableOccurrence"
                                :enable-compare-checklist="enableCompareChecklist"
                                :business-allow-edit-environment="businessAllowEditEnvironment"
                                :foreign-key="form.checklistId" :enterpriseId="form.enterpriseId"/>

        </t-form-tab>

        <t-form-tab title="Contrato Locação" hash="contact" v-if="accountModule === 'estate'"
                    :disabled="!relationAccessPageGeneral('checklist-executed-contact')" lazy>


          <div v-show="form.businessTypeSurvey === SurveyType.type.ESTATE">


            <t-input v-model="form.customer" label="Locador (principal)" fixed highlight/>
            <small>Para alterar locador principal acesse o
              <b-link :to="{path: '/place/enterprise/'+form.enterpriseNumber}" target="_blank">cadastro do imóvel
              </b-link>
            </small>

            <h6 class="mb-2 mt-2 border-bottom pb-2">Locatário/Fiador ou Outros Locadores</h6>

          </div>


          <ChecklistContact :only-view="!isUpdate()" :foreign-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Apontamentos" v-if="enableOccurrence && form.businessTypeSurvey !== SurveyType.type.BUDGET"
                    hash="occurrence"
                    lazy>

          <ChecklistOccurrence :business-type-survey="form.businessTypeSurvey"
                               :user-access-budget-show-price="relationAccessSubValidation('sub-checklist-budget-show-price')"
                               :foreign-key="form.checklistId"/>

        </t-form-tab>

        <t-form-tab v-if="form.businessTypeSurvey  === SurveyType.type.BUDGET" title="Orçamento" hash="budget"
                    lazy>
          <ChecklistOccurrence :business-type-survey="form.businessTypeSurvey"
                               :quote-id="form.quoteId"
                               :quote-number="form.quoteNumber"
                               :quote-code-label="form.quoteCodeLabel"
                               :user-access-budget-show-price="relationAccessSubValidation('sub-checklist-budget-show-price')"
                               :foreign-key="form.checklistId" budget-enabled/>

        </t-form-tab>

        <t-form-tab title="Planta" v-if="enableOccurrence" hash="floor-plan" lazy>

          <t-msg info>Não utilizada</t-msg>
          <!--Imagens com as plantas e os pinos inseridos.-->

        </t-form-tab>

        <t-form-tab title="Atividades" hash="activity" lazy>

          <ChecklistModelActivity :foreign-key="form.checklistId"/>

        </t-form-tab>

        <!-- Em desenvolvimento!!!! -->
        <t-form-tab v-if="1===2" title="Conteúdo" hash="content"
                    :disabled="!relationAccessPageGeneral('checklist-executed-content')" lazy>

          <t-msg info class="mb-3">Cadastre conteúdos para serem inseridos junto com os relatórios fotográficos
            relacionados a esta inspeção, podendo especificar no início ou no final a exibição do conteúdo desta
            inspeção.
          </t-msg>

          <ChecklistContent :foreign-key="form.checklistId"/>

        </t-form-tab>

        <t-form-tab title="GUT" v-if="enableOccurrence" hash="risk" @onClick="getRiskList()" lazy>

          <t-table
              :items="riskList"
              :fields="riskFields"
              :user-auth="userAuth"
              disable-link-primary-column
              disable-actions-column
              primary-key-column="position" link-primary-column="position">

            <template #first-column="{item,index}">

              <b-button variant="outline-primary" @click="openDialogItemOccurrence(item)" size="sm">{{ index + 1 }}º
              </b-button>

            </template>


            <template #item(local)="{item}">

              {{ item.environment }}
              <br/>
              <small>{{ item.spotFolder }}</small>

            </template>

            <template #item(riskResult)="{item}">

              <t-occurrence-risk hide-label :type-severity="item.typeSeverity" :type-urgency="item.typeUrgency"
                                 :type-trend="item.typeTrend"/>

            </template>


          </t-table>


        </t-form-tab>


        <t-form-tab title="Gráficos" v-if="enableOccurrence" hash="chart" @onClick="getDashboard()" lazy>


          <b-row style="width: 100%; margin: auto; max-width: 1000px; margin:auto; border-bottom: solid 1px #ccc"
                 v-show="dashboard.pathology !== undefined && dashboard.pathology.length > 0" class="mb-3 pb-3">

            <b-col cols="6">


              <div style="max-height: 350px; overflow-y: auto" class="mt-3">

                <table class="align-middle table table-borderless table-striped table-hover">
                  <thead>
                  <tr>
                    <th class="text-center"></th>
                    <th>Anomalias - Tipo</th>
                    <th class="text-center">Qtd.</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(pathology,index) in dashboard.pathology" :key="pathology.typePathologyId">
                    <td class="text-center text-muted">{{ ++index }}º</td>
                    <td>
                      <div style="font-size: 14px">{{ pathology.typePathology }}</div>

                      <div class="d-flex align-items-center justify-content-start border b-radius">
                        <div class="mb-2 ml-2 mt-2 mr-2 badge badge-dot badge-dot-xl"
                             :style="{'background-color': pathology.sectorColor}"></div>
                        <div class="small">{{ pathology.sector }}</div>
                      </div>

                    </td>

                    <td class="text-center">
                      {{ pathology.qtyRecords }}
                    </td>
                  </tr>

                  </tbody>
                </table>

              </div>


            </b-col>

            <b-col cols="6">

              <apexchart type="pie" class="mt-4" :options="chartSectorOptions" v-if="chartSectorSeries.length > 0"
                         :series="chartSectorSeries"></apexchart>

            </b-col>

          </b-row>

          <b-row style="width: 100%; margin: auto; max-width: 1000px; margin:auto; border-bottom: solid 1px #ccc"
                 v-show="dashboard.anomalyOrigin !== undefined && dashboard.anomalyOrigin.length > 0" class="mb-3 pb-3">

            <b-col cols="6">


              <div style="max-height: 350px; overflow-y: auto" class="mt-3">

                <table class="align-middle table table-borderless table-striped table-hover">
                  <thead>
                  <tr>
                    <th class="text-center"></th>
                    <th>Anomalias - Origem</th>
                    <th class="text-center">Qtd.</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(anomalyOrigin,index) in dashboard.anomalyOrigin" :key="anomalyOrigin.typeAnomalyOrigin">
                    <td class="text-center text-muted">{{ ++index }}º</td>
                    <td>
                      <div style="font-size: 14px">{{ anomalyOrigin.typeAnomalyOriginAutomatically }}</div>

                    </td>

                    <td class="text-center">
                      {{ anomalyOrigin.qtyRecords }}
                    </td>
                  </tr>

                  </tbody>
                </table>

              </div>


            </b-col>

            <b-col cols="6">

              <apexchart type="pie" class="mt-4" :options="chartAnomalyOriginOptions"
                         v-if="chartAnomalyOriginSeries.length > 0"
                         :series="chartAnomalyOriginSeries"></apexchart>

            </b-col>

          </b-row>

          <b-row style="width: 100%; margin: auto; max-width: 1000px; margin:auto; border-bottom: solid 1px #ccc"
                 v-show="dashboard.criticality !== undefined && dashboard.criticality.length > 0" class="mb-3 pb-3">

            <b-col cols="6">


              <div style="max-height: 350px; overflow-y: auto" class="mt-3">

                <table class="align-middle table table-borderless table-striped table-hover">
                  <thead>
                  <tr>
                    <th class="text-center"></th>
                    <th>Criticidade</th>
                    <th class="text-center">Qtd.</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(criticality,index) in dashboard.criticality" :key="criticality.typeCriticalityId">
                    <td class="text-center text-muted"
                        :class="{[criticality.typeCriticalityLineClass] : criticality.typeCriticalityLineClass !== '' }">
                      {{ ++index }}º
                    </td>
                    <td>
                      <div style="font-size: 14px" :style="{'color': criticality.typeCriticalityColor}">
                        {{ criticality.typeCriticality }}
                      </div>

                    </td>

                    <td class="text-center">
                      {{ criticality.qtyRecords }}
                    </td>
                  </tr>

                  </tbody>
                </table>

              </div>


            </b-col>

            <b-col cols="6">

              <apexchart type="pie" class="mt-4" :options="chartCriticalityOptions"
                         v-if="chartCriticalitySeries.length > 0" :series="chartCriticalitySeries"></apexchart>

            </b-col>

          </b-row>


        </t-form-tab>


      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageChecklistMixin from "@/mixins/page/pageChecklistMixin";
import ChecklistPlatformType from "@/model/types/modules/checklist/ChecklistPlatformType";
import ChecklistEnvironment from "@/views/modules/checklist/Checklist/ChecklistEnvironment";
import ChecklistOccurrence from "@/views/modules/checklist/Checklist/ChecklistOccurrence";
import ChecklistModelActivity from "@/views/modules/checklist/Checklist/ChecklistModelActivity";
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";
import EnterpriseStepService from "@/services/modules/place/EnterpriseStep.service";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import ChecklistContent from "@/views/modules/checklist/ChecklistContent";
import SurveyType from "@/model/types/modules/checklist/SurveyType";
import ChecklistContact from "@/views/modules/checklist/Checklist/ChecklistContact";
import ChecklistShareType from "@/model/types/modules/checklist/ChecklistShareType";
import ChecklistService from "@/services/modules/checklist/Checklist.service";
import ChecklistEnvironmentOccurrenceDialog
  from "@/views/modules/checklist/Checklist/ChecklistEnvironmentOccurrenceDialog.vue";
import tOccurrenceRisk from "@/components/template/form/input/t-occurrence-risk.vue";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageChecklistMixin],
  components: {
    tOccurrenceRisk,
    ChecklistEnvironmentOccurrenceDialog,
    ChecklistEnvironment, ChecklistOccurrence, ChecklistModelActivity, ChecklistContent, ChecklistContact
  },
  name: 'ChecklistForm',
  data() {
    return {
      ChecklistShareType,
      SurveyType,
      StatusChecklistType,
      ChecklistPlatformType,
      path: "checklist", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "checklistId",
      form: {
        checklistId: 0,
        checklistNumber: 0,
        enterpriseId: 0,
        enterpriseStepId: 0,
        finalDate: "",
        finalLat: 0,
        finalLng: 0,
        initialDate: "",
        initialLat: 0,
        initialLng: 0,
        inspectorId: 0,
        scheduleId: 0,
        typeChecklistId: 0,
        platformOrigin: 0,
        enableAllSectors: false,
        processedDate: "",
        enableSingleEnvironment: 0,
        environmentId: 0,
        statusChecklist: 0,
        qtyGeneralItemsOk: 0,
        qtyGeneralItemsTotal: 0,
        qtyGeneralOccurrencesDone: 0,
        qtyGeneralOccurrencesNew: 0,
        qtyGeneralOccurrencesPending: 0,
        qtyGeneralOccurrencesSignaled: 0,
        qtyGeneralOccurrencesTotal: 0,
        qtyEnvironmentFinished: 0,
        qtyEnvironmentPending: 0,
        qtyEnvironmentStarted: 0,
        qtyEnvironmentTotal: 0,
        typeChecklistStatus: "",
        issueDate: "",
        compareChecklistId: 0,
        note: "",
        status: 1,
        mobileDevice: {
          device: "",
          systemType: "",
          systemVersion: "",
          internetType: "",
        },

        /*Campos vindos da view*/
        typeChecklist: "",
        scheduleStartDate: "",
        scheduleStartTime: "",
        scheduleFinishDate: "",
        scheduleFinishTime: "",
        scheduleSharing: false,
        elapsedTimeTotal: "",
        sectors: "",
        enterprise: "",
        enterpriseCodeLabel: "",
        enterpriseFederalTaxpayer: "",
        enterpriseAddressFull: "",
        enterpriseNeighborhood: "",
        enterpriseZipcode: "",
        enterpriseCityFull: "",
        inspector: "",
        businessTypeSurvey: 0,
        /*Somente quando é ambiente único*/
        environment: "",
        environmentCodeLabel: "",
        spotFolderId: 0,
        spotFolder: "",
        shareType: 0,
        shareURL: "",
        /*Campos especificos para modelos especiais*/
        estateClean: "",
        estateLeaseGuarantee: "",
        estateLeaseInitialDate: "",
        estateLeaseFinalDate: "",
        estateLeaseIssueDate: "",
        estateIntroText: "",
        estateFinishText: "",

        /*-------------------------------*/
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      checklistOrigin: {},
      accountModule: "",
      enableOccurrence: false,
      enableCompareChecklist: false,
      businessAllowEditEnvironment: false,
      onDownloadChecklistPhotos: false,
      enterpriseLabelByModule: "",
      tabIndex: 0,
      reverseFinish: false,
      enterpriseStepOptions: [],
      riskList: [],
      riskFields: [
        {key: "position", label: "Posição"},
        {key: "local", label: "Local"},
        {key: "typeChecklistItem", label: "Item"},
        {key: "typePathologyAutomatically", label: "Anomalia"},
        {key: "typeAnomalyOriginAutomatically", label: "Origem"},
        {key: "riskResult", label: "GUT"},
      ],
      dashboard: {},
      chartSectorSeries: [],
      chartSectorOptions: {
        chart: {
          width: 200,
          type: 'pie',
        },
        colors: [],
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        },
      },
      chartAnomalyOriginOptions: {
        chart: {
          width: 200,
          type: 'pie',
        },
        colors: [],
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        },
      },
      chartAnomalyOriginSeries: [],
      chartCriticalitySeries: [],
      chartCriticalityOptions: {
        chart: {
          width: 200,
          type: 'pie',
        },
        colors: [],
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        },
      },
      modalOccurrenceItemShow: false,
      modalChecklistEnvironmentId: 0,
      modalOccurrenceItem: {},
      modalOccurrenceItemId: 0,            /* checklistItemId */
      modalOccurrenceItemName: ""          /*typeChecklistItem*/,
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.accountModule = ui.getAccountModule()

    },
    async mountedContinued() {

      if (this.form.enterpriseId > 0) {

        await EnterpriseStepService.selectList(this.form.enterpriseId).then((list) => {
          this.enterpriseStepOptions = list
        }).catch(error => this.responseError(error))

      }

      if (this.form.statusChecklist === StatusChecklistType.type.FINISHED && this.command === 'update') {
        this.command = 'view'
      } else if (this.form.statusChecklist === StatusChecklistType.type.PENDING && this.command === 'view') {
        this.command = 'update'
      }


      if (this.form.businessTypeSurvey >= SurveyType.type.OCCURRENCE && this.form.businessTypeSurvey !== SurveyType.type.ESTATE) {
        this.enableOccurrence = true
      }

      if (this.form.compareChecklistId > 0) {
        this.enableCompareChecklist = true
      }

      if (this.accountModule === 'estate') {
        this.enterpriseLabelByModule = "Imóvel"
      } else {
        this.enterpriseLabelByModule = "Empr."
      }

      await this.getResumeChecklistOrigin()

      this.businessAllowEditEnvironment = this.getRenderRule("businessAllowEditEnvironment")


      this.getRiskList()
      this.getDashboard()

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      //await http.get(this.path + "/checkIsFinished/" + this.form.checklistId).then(async () => {
      if (this.isDelete()) {
        await this.setSendingDefault()
      } else {

        ui.msgConfirm(this, '', 'Tem certeza que deseja finalizar a inspeção?', async () => {

          const id = this.form[this.fieldKey]

          await this.setSending(
              id,
              (response) => {
                this.setRedirect(this.getPath(), response[this.fieldKey], this.command, 0, "", true)
              },
              (response) => {

                if (this.form.businessTypeSurvey === SurveyType.type.BUDGET && this.objValid(response.quote) && this.objValid(response.quote.quoteCodeLabel)) {
                  this.goPath('/business/quote/' + response.quote.quoteNumber, {
                    codSuccess: 100,
                    returnMessage: 'Inspeção finalizada com sucesso e orçamento gerado!'
                  })
                } else {
                  this.setRedirect(this.getPath(), response[this.fieldKey], this.command, 0, "", true)
                }

              }, (response) => {
                this.setRedirect(this.getPath(), response[this.fieldKey], this.command, 0, "", true)
              },
          )

          await this.setSendingDefault(() => {


          })

        }, 'Finalizar Inspeção')

      }
      //}).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async downloadChecklistPhotos() {


      if (this.form.statusChecklist === StatusChecklistType.type.FINISHED) {

        const nameFile = ui.nameFile('inspeção_' + this.form.checklistNumber, 'zip')

        this.onDownloadChecklistPhotos = true

        await http.download("checklist/download/" + this.form.checklistId, nameFile)
            .catch(error => ui.generalResponseError(this, error))

        this.onDownloadChecklistPhotos = false


      } else {

        ui.msg(this, 'Download após a finalização', 'Para realização do download de todas as fotos de uma única vez é necessário realizar a finalização da inspeção antes.')

      }


    },

    onShareURL() {

      const message = "Confira o link para compartilhamento das fotos da inspeção<br /><br /><a target='_blank' href='" + this.form.shareURL + "'>" + this.form.shareURL + "</a>"

      ui.msg(this, 'Link para compartilhamento de fotos', message)

    },

    async getChecklist() {

      await this.setInitiate(false)

    },

    async getRiskList() {

      await http.get(this.path + '/risk/' + this.form.checklistId).then(response => {

        this.riskList = response.data

      }).catch(error => ui.generalResponseError(this, error))

    },


    async getDashboard() {

      await http.get(this.path + '/dashboard/' + this.form.checklistId).then(response => {

        this.dashboard = response.data

        this.chartSectorOptions.labels = []
        this.chartSectorOptions.colors = []
        this.chartSectorSeries = []

        this.chartAnomalyOriginOptions.labels = []
        this.chartAnomalyOriginOptions.colors = []
        this.chartAnomalyOriginSeries = []

        this.chartCriticalityOptions.labels = []
        this.chartCriticalityOptions.colors = []
        this.chartCriticalitySeries = []

        for (const item of this.dashboard.sector) {

          this.chartSectorOptions.labels.push(item.sector)
          this.chartSectorOptions.colors.push(item.sectorColor)
          this.chartSectorSeries.push(item.qtyRecords)

        }

        const anomalyOriginColors = {
          1: '#e74c3c', // Endógena (vermelho)
          2: '#3498db', // Exógena (azul)
          3: '#f39c12', // Funcional / Uso (laranja)
          20: '#95a5a6' // Não determinada (cinza)
        }

        for (const item of this.dashboard.anomalyOrigin) {

          const color = anomalyOriginColors[item.typeAnomalyOriginAutomatically] || '#7f8c8d'

          this.chartAnomalyOriginOptions.labels.push(item.typeAnomalyOriginAutomatically)
          this.chartAnomalyOriginOptions.colors.push(color)
          this.chartAnomalyOriginSeries.push(item.qtyRecords)

        }

        for (const item of this.dashboard.criticality) {

          let color = item.typeCriticalityColor

          if (color === null || color === '') {
            color = "#ccc"
          }

          this.chartCriticalityOptions.labels.push(item.typeCriticality)
          this.chartCriticalityOptions.colors.push(color)
          this.chartCriticalitySeries.push(item.qtyRecords)

        }

      }).catch(error => ui.generalResponseError(this, error))

    },

    async updateGeneralInformation() {

      if (this.isUpdate()) {

        const generalInformation = {
          checklistId: this.form.checklistId,
          note: this.form.note,
          estateClean: this.form.estateClean,
          estateLeaseGuarantee: this.form.estateLeaseGuarantee,
          estateLeaseInitialDate: this.form.estateLeaseInitialDate,
          estateLeaseFinalDate: this.form.estateLeaseFinalDate,
          estateLeaseIssueDate: this.form.estateLeaseIssueDate,
          estateIntroText: this.form.estateIntroText,
          estateFinishText: this.form.estateFinishText,
        }

        await crudGeneral.update(this.path + "/updateGeneral", generalInformation).then(
            //() => ui.toast(this, "Informação", "Informações salvas com sucesso!")
        ).catch(error => this.responseError(error))

      }

    },

    async updateEnterpriseStep() {

      if (this.form.enterpriseStepId > 0) {

        const checklistStepUpdate = {
          checklistId: this.form.checklistId,
          enterpriseStepId: this.form.enterpriseStepId,
        }

        await crudGeneral.update(this.path + "/updateStep", checklistStepUpdate).then(
            () => ui.toast(this, "Informação", "Fase atualizada com sucesso!")
        ).catch(error => this.responseError(error))

      }

    },

    async confirmReverse() {

      let complementMsg = ''

      if (this.form.businessTypeSurvey === SurveyType.type.BUDGET) {
        complementMsg = '<br /><br />Atenção o orçamento gerado automaticamente através desta inspeção será excluído também (incluíndo possíveis alterações realizadas no orçamento), verifique se realmente é necessário ou altere diretamente no orçamento.'
      }

      ui.msgConfirm(this, 'ESTORNO DA FINALIZAÇÃO DA INSPEÇÃO', '<span class="text-danger">Tem certeza que deseja realizar o estorno da finalização desta Inspeção <b>' + this.form.checklistNumber + '</b>?' + complementMsg + '<br /><br />Somente é permitido se esta for a última inspeção realizada neste mesmo empreendimento por consistência de dados.', async () => {

        this.reverseFinish = true

        await http.get(this.userAuth.currentPage.path + "/reverse-finish/" + this.form.checklistId).then(async () => {

          //await this.goPath(this.userAuth.currentPage.path + '/' + this.form.checklistNumber)

          //Somente reload é suficiente, pois é possível editar os ambientes em modo visualização externo
          await ui.reload()

        }).catch(error => ui.generalResponseError(this, error))

        this.reverseFinish = false

      })

    },

    async getResumeChecklistOrigin() {

      if (this.form.compareChecklistId > 0) {

        await ChecklistService.getResume("id", this.form.compareChecklistId).then(async checklistResume => {
          this.checklistOrigin = checklistResume
        })

      }

    },


    async openDialogItemOccurrence(item) {

      this.modalOccurrenceItemShow = true
      this.modalOccurrenceItem = item
      this.modalChecklistEnvironmentId = item.checklistEnvironmentId
      this.modalOccurrenceItemId = item.checklistItemId
      this.modalOccurrenceItemName = item.typeChecklistItem

      this.openDialogForm('modal-checklist-item-occurrence', '')

    },

    onCloseModalOccurrenceItem() {
      this.modalOccurrenceItemShow = false
      this.getRiskList()
    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

